import React from "react";
import { ModeRendererProps } from "./types";

export function LockMode({ brand }: ModeRendererProps) {
  return (
    <g transform="translate(397 540)">
      <circle r="300" fill="none" stroke={brand.violet} strokeOpacity="0.2" />
      <circle r="220" fill="none" stroke={brand.aqua} strokeOpacity="0.2" />
      <use href="#padlock" fill={brand.deep} stroke={brand.white} strokeWidth="6" />
      {Array.from({ length: 8 }).map((_, i) => (
        <circle key={i} r={120 + i * 18} fill="none" stroke={i % 2 ? brand.aqua : brand.violet} strokeOpacity="0.35" strokeDasharray="8 10" />
      ))}
      {Array.from({ length: 10 }).map((_, i) => (
        <circle key={i} cx={Math.cos(i) * 160} cy={Math.sin(i) * 120} r="3.2" fill={i % 2 ? brand.amber : brand.green} />
      ))}
    </g>
  );
}
